import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { FundDetailsDTO } from "../../ajax/types/FundDetailsDTO";
import { StackPanelComponent, IStackPanelOptions } from "./layout/StackPanelComponent";
import { SelectTaxonComponent } from "./SelectTaxonComponent";
import { date, numeric, LoadingComponent } from "jsl-ui";
import { ImageGallerieComponent } from "./image-gallerie/ImageGallerieComponent";
import { MapComponent } from "./map/MapComponent";
import { ExpertController } from "../../ajax/ExpertController";
import { refreshPendingCount } from "../../helper/ajax";
import { UserNameComponent } from "./UserNameComponent";
import { EditFundComponent } from "../components/edit-fund/EditFundComponent";


export class CheckFundComponent implements IJSLComponent {

    public processed = false;

    private node: IJSLVNode;
    private editFundComponent: EditFundComponent;

    public constructor(private fund: FundDetailsDTO) {
        this.preRender();
    }

    public render(): IJSLVNode {
        return <div>{this.node}</div>;
    }

    private preRender() {
        const x = this.fund;
        this.editFundComponent = new EditFundComponent(x);
        this.node = <div id={"f-" + x.fundId} class="highlight-box mb-30" style="position:relative;max-width:50rem;margin-left:auto;margin-right:auto;">

            <h3>Fund Details</h3>
            <div>
                Hochgeladen: {date.format(x.erstelltAm)} / von: <a href="#">{new UserNameComponent(x.erstelltVon)}</a>
            </div>
            {x.latitude && x.longitude ? new MapComponent([{ lat: x.latitude, lon: x.longitude, verschleiert: x.koordinatenVerschleiert }],
                { height: "12rem", maxWidth: "30rem", defaultZoom: 6 }) : null}
            {new ImageGallerieComponent(x.images)}
            {this.editFundComponent}
            <h3>Freigabe</h3>
            <div>
                <textarea class="common-textarea form-control mt-20" id={"check-kommentar-" + x.fundId}
                    placeholder="Kommentar / Begründung"></textarea>
                <div class="mt-20">
                    <button class="genric-btn default-border mr-20" click={() => this.reject(x.fundId)}>Ablehnen</button>
                    <button class="genric-btn primary" click={() => this.approve(x.fundId)}>Freigeben</button>
                </div>
            </div>

        </div>;
    }

    private reject(id: number) {
        this.node = new LoadingComponent().render();
        const comment = (document.getElementById("check-kommentar-" + id) as HTMLTextAreaElement).value;
        ExpertController.Reject({ comment, id }).then(() => {
            this.node = null;
            this.processed = true;
            refresh();
            refreshPendingCount();
        });
    }

    private approve(id: number) {
        this.node = new LoadingComponent().render();
        const comment = (document.getElementById("check-kommentar-" + id) as HTMLTextAreaElement).value;
        this.editFundComponent.getData(this.fund, this.fund);
        ExpertController.Approve({ comment, id, data: this.fund }).then(() => {
            this.node = null;
            this.processed = true;
            refresh();
            refreshPendingCount();
        });
    }


}
